import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const RefulfillmentToolsLocation_ = z.object({
  sourceTeamId: z.string(),
  sourceTeamName: z.string(),
  sourceLocationId: z.string(),
  name: z.string(),
  /** Whether the merchant has a Shopify location mapped to this location. */
  hasShopifyMapping: z.boolean(),
});
export const RefulfillmentToolsLocation: z.ZodType<RefulfillmentToolsLocation> =
  RefulfillmentToolsLocation_;
export interface RefulfillmentToolsLocation extends z.infer<
  typeof RefulfillmentToolsLocation_
> {}

/** Source locations whose returns center has refulfillment on for the merchant. */
export const getRefulfillmentToolsLocations = unaryRpc({
  name: "getRefulfillmentToolsLocations" as const,
  input: z.object({ merchantTeamId: zExt.objectId() }),
  output: z.object({
    /** The merchant's saved inventory push buffer. */
    inventoryPushMinimumQuantity: z.number(),
    locations: z.array(RefulfillmentToolsLocation),
  }),
});
